const CALLOUT_TYPES = {
    EDIT_FOLDER: 'editFolder',
    REARRANGE_ITEMS: 'rearrangeItems',
};

export function favoritesNotificationsReducer(state, action) {
    switch (action.type) {
        case 'SHOW_FAVORITES_REARRANGE_ITEMS_CALLOUT':
            return {
                ...state,
                callout: { [CALLOUT_TYPES.REARRANGE_ITEMS]: true },
            };
        case 'SHOW_FAVORITES_FOLDER_CALLOUT':
            return {
                ...state,
                callout: { [CALLOUT_TYPES.EDIT_FOLDER]: true },
            };
        default:
            return state || { callouts: {} };
    }
}
